<template>
  <div class="grid-view check-rule">
    <div class="main-content">
      <div class="section operations" style="height: 39px;">
        <div class="triggers">
          <div>
            <template v-if="currOptStatus===optStatusDef.normal">
              <el-button type="primary" @click="showAdd">{{ $t('SystemMaintenance.Add') }}</el-button>
              <el-button type="primary" @click="showEdit">{{ $t('SystemMaintenance.Edit') }}</el-button>
              <el-button type="danger" @click="toDel">{{ $t('SystemMaintenance.Delete') }}</el-button>
              <el-button type="primary" @click="refresh">{{ $t('SystemMaintenance.Refresh') }}</el-button>
              <el-button type="primary" @click="editCheckRuleSetting">{{ $t('Tool.VerificationSettings') }}</el-button>
            </template>
            <template v-else>
              <el-button type="primary" @click="save">{{ $t('SystemMaintenance.Save') }}</el-button>
              <el-button type="danger" @click="cancel">{{ $t('SystemMaintenance.Cancel') }}</el-button>
            </template>
          </div>
        </div>
      </div>
      <cargo-left-right-resize
        :left-style="{display: 'flex', flexDirection: 'column',width:'25%'}"
        :right-style="{display: 'flex', flexDirection: 'column',width:'75%'}"
        style="min-height:100%"
      >
        <template slot="left">
          <!--验证规则-->
          <el-card class="box-card left-rules">
            <div slot="header">
              <span>{{ $t('SystemMaintenance.ValidationRules') }}</span>
            </div>
            <div :loading="loading" class="grid-wrapper" :class=" isEdit? 'isEdit' : ''">
              <div v-show="isEdit" class="pure-loading-mask" />
              <cargo-ag-grid
                :show-side-bar="false"
                :grid-options="checkRuleGrid.gridOptions"
                :column-defs="checkRuleGrid.columnDefs"
                :row-data="checkRuleGrid.rowData"
              />
            </div>
            <div v-if="isEdit" class="app-main-inner-row">
              <el-form style="width:100%;" label-position="left" label-width="90px">
                <el-form-item :label="$t('SystemMaintenance.RuleName')">
                  <el-input v-model="oneCheckRule.ruleName" :disabled="!isEdit" />
                </el-form-item>
                <el-form-item :label="$t('SystemMaintenance.ValidationNode')">
                  <el-select v-model="oneCheckRule.checkNode" :disabled="!isEdit" filterable @change="onCheckNodeChange">
                    <el-option v-for="item in checkNodes" :key="item.code" :label="item.chineseName" :value="item.code" />
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('SystemMaintenance.ValidationType')">
                  <el-select v-if="oneCheckRule.checkNode === CheckRuleConstants.NODE_INVOICE_CONFIRM_OR_RECEPT.code || oneCheckRule.checkNode === CheckRuleConstants.NODE_SAVE_INVOICE.code" v-model="oneCheckRule.checkCategory" :disabled="!isEdit">
                    <el-option
                      v-for="item in checkLogicCriterias"
                      :key="item.code"
                      :label="item.chineseName"
                      :value="item.code"
                    />
                  </el-select>
                  <el-select v-if="oneCheckRule.checkNode !== CheckRuleConstants.NODE_INVOICE_CONFIRM_OR_RECEPT.code && oneCheckRule.checkNode !== CheckRuleConstants.NODE_SAVE_INVOICE.code" v-model="oneCheckRule.checkCategory" :disabled="!isEdit">
                    <el-option
                      v-for="item in checkCriterias"
                      v-show="filterCheckCriteria(oneCheckRule.checkNode, item.code)"
                      :key="item.code"
                      :label="item.chineseName"
                      :value="item.code"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('SystemMaintenance.ValidationMode')">
                  <el-select v-if="oneCheckRule.checkNode === CheckRuleConstants.NODE_INVOICE_CONFIRM_OR_RECEPT.code || oneCheckRule.checkNode === CheckRuleConstants.NODE_SAVE_INVOICE.code" v-model="oneCheckRule.checkMode" :disabled="!isEdit">
                    <el-option v-for="item in checkErrorModes" :key="item.code" :label="item.chineseName" :value="item.code" />
                  </el-select>
                  <el-select v-if="oneCheckRule.checkNode !== CheckRuleConstants.NODE_INVOICE_CONFIRM_OR_RECEPT.code && oneCheckRule.checkNode !== CheckRuleConstants.NODE_SAVE_INVOICE.code" v-model="oneCheckRule.checkMode" :disabled="!isEdit">
                    <el-option v-for="item in checkModes" :key="item.code" :label="item.chineseName" :value="item.code" />
                  </el-select>
                </el-form-item>
                <el-form-item v-show="oneCheckRule.checkMode===3" :label="$t('SystemMaintenance.EmailAddress')">
                  <el-input v-model="oneCheckRule.remarks" :disabled="!isEdit" />
                </el-form-item>
                <div class="form-tip">
                  <span>{{ $t('SystemMaintenance.AllowOperationAfterValidationFails') }}</span>
                  <el-radio-group v-model="oneCheckRule.continueCheck" :disabled="!isEdit">
                    <el-radio :label="true">{{ $t('SystemMaintenance.Yes') }}</el-radio>
                    <el-radio :label="false">{{ $t('SystemMaintenance.No') }}</el-radio>
                  </el-radio-group>
                </div>
                <el-form-item v-if="hqChecked" label-width="10px" style="margin-top: 20px">
                  <span>{{ $t('SystemMaintenance.CheckRuleToAllBranch') }}</span>
                  <el-checkbox v-model="oneCheckRule.useHQ" no="useHQ" style="margin-left: 20px" />
                </el-form-item>
                <el-button v-if="hqChecked" type="primary" @click="showBranchSelectDialog">{{ $t('SystemMaintenance.SetExclusionOffices') }}</el-button>
                <el-input v-if="hqChecked" v-model="branchSelectDialog.showExclusionOfficeIds" :disabled="true" />
              </el-form>
            </div>
          </el-card>
          <branch-select-dialog
            :visible.sync="branchSelectDialog.visible"
            :office-list="branchSelectDialog.officeList"
            :value="branchSelectDialog.value"
            @callback="branchSelectDialog.callback"
          />
        </template>
        <template slot="right">
          <cargo-left-right-resize
            :left-style="{display: 'flex', flexDirection: 'column',width:'30%'}"
            :right-style="{display: 'flex', flexDirection: 'column',width:'70%'}"
            style="height: 100%;min-height: 300px"
          >
            <template slot="left">
              <!--分公司-->
              <el-card class="box-card company">
                <div slot="header">
                  <span>{{ $t('SystemMaintenance.Company') }}</span>
                </div>
                <div class="section grid-wrapper">
                  <cargo-ag-grid
                    :disabled="true"
                    :show-side-bar="false"
                    :grid-options="officeGrid.gridOptions"
                    :column-defs="officeGrid.columnDefs"
                    :row-data="officeRowData"
                  />
                </div>
              </el-card>
            </template>
            <template slot="right" class="check-rule-right">
              <cargo-up-down-resize
                :up-style="{display: 'flex', flexDirection: 'column', paddingBottom: '5px'}"
                :down-style="{display: 'flex', flexDirection: 'column', paddingTop: '5px'}"
                style="height: 100%;flex-direction: column;"
              >
                <template slot="up">
                  <!--验证条件-->
                  <check-criteria ref="checkCriteria" :disabled="true" :check-rule="oneCheckRule" :is-edit-check-rule="isEdit && checkboxSelection" />
                </template>
                <template slot="down">
                  <!--验证表达式-->
                  <check-expression ref="checkExpression" :check-rule="oneCheckRule" :is-edit-check-rule="isEdit" />
                </template>
              </cargo-up-down-resize>
            </template>
          </cargo-left-right-resize>
        </template>
      </cargo-left-right-resize>
    </div>
    <!-- 验证规则设置 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="checkRuleSetDialog.visible"
      :title="$t('Tool.VerificationSettings')"
      width="522px"
      :close-on-click-modal="false"
    >
      <el-form label-width="100px" style="margin-top: 15px;">
        <el-form-item>
          <span slot="label" class="blue">{{ $t('SystemMaintenance.PopupMode') }}</span>
          <el-checkbox v-model="checkRuleSetDialog.form.popupMode" @change="onPopupModeChange" />
          <span style="margin-left: 2px">{{ $t('SystemMaintenance.DisplayWhenThereIsValidation') }}</span>
        </el-form-item>
        <el-form-item :label="$t('SystemMaintenance.ValidationNode')">
          <cargo-advance-select
            :disabled="!checkRuleSetDialog.form.popupMode"
            filterable
            :multiple="true"
            :static-options="checkNodes"
            :default-multiple-value="toNumArray(checkRuleSetDialog.form.multiCheckNode)"
            tag-name="chineseName"
            tag-value="code"
            placeholder=" "
            style="width: 350px"
            @parentCallBack="p=>{checkRuleSetDialog.form.multiCheckNode=toTxt(p.value)}"
          />
        </el-form-item>
        <el-form-item :label="$t('SystemMaintenance.ValidationMode')">
          <cargo-advance-select
            :disabled="!checkRuleSetDialog.form.popupMode"
            filterable
            :multiple="true"
            :static-options="checkModes"
            :default-multiple-value="toNumArray(checkRuleSetDialog.form.multiCheckMode)"
            tag-name="chineseName"
            tag-value="code"
            placeholder=" "
            style="width: 350px"
            @parentCallBack="p=>{checkRuleSetDialog.form.multiCheckMode=toTxt(p.value)}"
          />
        </el-form-item>
        <el-form-item label=" ">
          <div style="display: flex;">
            <i class="el-icon-warning" style="color: #E6A23C;line-height: 28px;" />
            <span :title="$t('SystemMaintenance.TheBeAppliedToOffices')" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;margin-left: 5px;">{{ $t('SystemMaintenance.TheBeAppliedToOffices') }}</span>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="onSaveCheckRuleSet">{{ $t('Message.Confirm2') }}</el-button>
        <el-button @click="checkRuleSetDialog.visible=false">{{ $t('Message.Cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import checkExpression from './checkRule/checkExpression'
import checkCriteria from './checkRule/checkCriteria'
import { getLoading } from '@/utils/utilBaseElement'
import {
  getCheckRuleByUuid,
  getCheckRuleList,
  delCheckRule,
  saveCheckRuleFunc, beforeSaveValid
} from '@/api/sysManage/baseConfig/checkRuleConfig'
import { getOfficeList } from '@/api/office'
import { getGridSelectedIds } from '@/utils/agGrid'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { Assert } from '@/utils/validate'
import { getNameByCode } from '@/class/cargo/model/parameters/CommonState'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import cargoUpDownResize from '@/components/Cargo/Common/cargoUpDownResize'
import BranchSelectDialog from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/BranchSelectDialog'
import { cache, cacheName } from '@/utils/cacheManager'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { Message } from '@/utils/Message'
import lang from '@/lang'
import { CheckRuleUtil } from '@/class/cargo/model/utils/CheckRuleUtil'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'

export default {
  name: 'CheckRuleConf',
  components: {
    BranchSelectDialog, cargoAdvanceSelect,
    checkExpression, checkCriteria, cargoLeftRightResize, cargoUpDownResize
  },
  filters: {},
  data() {
    const optStatus = { normal: 0, edit: 1 }
    return {
      loading: false,
      checkRuleGrid: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          defaultColDef: {
            resizable: true,
            filter: true
          },
          onRowClicked: this.onRuleRowClick
        },
        rowData: [],
        gridParams: {},
        gridApi: {},
        columnDefs: [
          {
            headerName: this.$t('SystemMaintenance.RuleName'),
            field: 'ruleName',
            width: 100
          }, {
            headerName: this.$t('SystemMaintenance.ValidationNode'),
            field: 'checkNode',
            width: 100,
            cellRenderer: (params) => {
              return this.getNameByCode(CheckRuleConstants.CHECK_NODES, params.value)
            }
          }, {
            headerName: this.$t('SystemMaintenance.ValidationType'),
            field: 'checkCategory',
            width: 100,
            cellRenderer: (params) => {
              console.log('params', params)
              return this.getNameByCode(CheckRuleConstants.CHECK_CATEGORIES, params.value)
            }
          }, {
            headerName: this.$t('SystemMaintenance.ValidationMode'),
            field: 'checkMode',
            width: 100,
            cellRenderer: (params) => {
              return this.getNameByCode(CheckRuleConstants.CHECK_MODES, params.value)
            }
          }, {
            headerName: this.$t('SystemMaintenance.ContinueValidation'),
            field: 'continueCheck',
            width: 100,
            cellRenderer: (params) => {
              return params.value ? this.$t('SystemMaintenance.Yes') : this.$t('SystemMaintenance.No')
            }
          }]
      },
      optStatusDef: optStatus,
      currOptStatus: optStatus.normal,
      officeGrid: {
        gridOptions: {
          suppressRowClickSelection: true,
          suppressCellSelection: true,
          rowSelection: 'multiple',
          defaultColDef: {
            filter: false,
            sortable: false,
            enableSorting: false,
            resizable: false,
            suppressMenu: true
          },
          columnDefs: this.getOfficeColumnDefs(),
          onSelectionChanged: event => {
            const rows = event.api.getSelectedRows()
            this.hqChecked = rows.findIndex(p => p.officeId === 1) > -1
          }
        },
        rowData: [],
        gridParams: {},
        gridApi: {}
      },
      checkNodes: [...CheckRuleConstants.CHECK_NODES],
      checkCriterias: CheckRuleConstants.CHECK_CATEGORIES,
      checkModes: [...CheckRuleConstants.CHECK_MODES],
      checkLogicCriterias: CheckRuleConstants.CHECK_LOGIC_CATEGORIES,
      checkErrorModes: CheckRuleConstants.CHECK_ERROR_MODES,
      NODE_SAVE_PARTNER: CheckRuleConstants.NODE_SAVE_PARTNER,
      NODE_COMMIT_PARTNER: CheckRuleConstants.NODE_COMMIT_PARTNER,
      CATEGORY_REQUIRE: CheckRuleConstants.CATEGORY_REQUIRE,
      initOneCheckRule: {},
      oneCheckRule: {
        uuid: '',
        ruleName: '',
        checkNode: '',
        checkCategory: '',
        checkMode: '',
        officeUuids: [],
        continueCheck: true,
        remarks: '',
        useHQ: false,
        exclusionOfficeIds: ''
      },
      hqChecked: false, // 总公司是否被勾选
      branchSelectDialog: {
        visible: false,
        value: [],
        callback: () => {},
        officeList: [],
        showExclusionOfficeIds: '' // 显示用豁免分公司
      },
      CheckRuleConstants: CheckRuleConstants,
      checkRuleSetDialog: {
        visible: false,
        form: {}
      }
    }
  },
  computed: {
    isEdit() {
      return this.optStatusDef.edit === this.currOptStatus
    },
    officeRowData() {
      if (this.officeGrid && this.officeGrid.rowData) {
        const currRuleOfficeUuids = [...this.oneCheckRule.officeUuids]
        const row = []
        for (const data of this.officeGrid.rowData) {
          if (currRuleOfficeUuids.includes(data.uuid)) {
            data.selected = true
          } else {
            data.selected = false
          }
          row.push(data)
        }
        return row
      }
      return []
    },
    checkboxSelection() {
      return this.oneCheckRule.checkNode !== CheckRuleConstants.NODE_SAVE_USER.code && this.oneCheckRule.checkNode !== CheckRuleConstants.NODE_CRM_CUSTOMER_INPUT_SAVE.code
    }
  },
  watch: {
    'oneCheckRule.checkNode'(newVal, oldVal) {
      if (oldVal === CheckRuleConstants.NODE_SAVE_USER.code || newVal === CheckRuleConstants.NODE_SAVE_USER.code) {
        this.officeGrid.gridOptions.api.setColumnDefs(this.getOfficeColumnDefs())
        this.oneCheckRule.officeUuids = []
      }
    },
    'oneCheckRule.exclusionOfficeIds'(newVal) {
      const values = newVal.split(',')
      this.branchSelectDialog.showExclusionOfficeIds = Array.from(values,
        p => ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(p), 'code')
      ).join(',')
    }
  },
  async created() {
    await cache.load(cacheName.OFFICE_LIST)
    this.branchSelectDialog.officeList = cache.officeList
  },
  beforeMount() {
    this.initOneCheckRule = { ...this.oneCheckRule }
    this.initData()
    // todo 模拟点击第一条数据
  },
  methods: {
    simulationClickSpecifiedRow() { // 模拟点击
      if (this.checkRuleGrid.rowData && this.checkRuleGrid.rowData.length > 0) {
        this.checkRuleGrid.gridOptions.api.setFocusedCell(0, this.checkRuleGrid.gridOptions.api.columnController.getAllDisplayedColumns()[0])
        this.getCheckRuleDetail(this.checkRuleGrid.rowData[0].uuid)
      }
    },
    getNameByCode,
    async onRuleRowClick(event) {
      await this.getCheckRuleDetail(event.data.uuid)
    },
    resetOfficeGridCheck() {
      this.officeGrid.gridOptions.api.setColumnDefs(this.getOfficeColumnDefs())
      this.officeGrid.gridOptions.api.refreshCells({ force: true })
    },
    setRuleGridCheck(uuids = []) {
      this.checkRuleGrid.gridOptions.api.forEachNode(node => {
        node.setSelected(uuids.includes(node.data.uuid))
      })
    },
    async refresh() {
      if (this.isEdit) { await this.$confirm(this.$t('SystemMaintenance.CurrentlyYouSureYouRefresh'), this.$t('SystemMaintenance.Prompt'), { type: 'warning' }) }
      this.initData()
    },
    initData(isRefreshOffice = true) {
      this.loading = getLoading()
      this.currOptStatus = this.optStatusDef.normal

      this.oneCheckRule = { ...this.initOneCheckRule }

      const promises = [this.fetchCheckRuleList()]
      if (isRefreshOffice) { // 公司没加载
        promises.push(getOfficeList({ tenantId: this.$store.getters.tenantId }).then((res) => {
          const firstRows = res.data.filter(p => p.officeId === 1)
          const tailRows = res.data.filter(p => p.officeId !== 1)
          this.officeGrid.rowData = [...firstRows, ...tailRows]
        }))
      }

      Promise.all(promises).then(() => {
        this.resetOfficeGridCheck()
        this.simulationClickSpecifiedRow()
        this.loading.close()
      }).catch((e) => {
        this.$message.error('初始化数据失败')
        this.loading.close()
      })
    },
    async fetchCheckRuleList() {
      await getCheckRuleList().then((res) => {
        this.checkRuleGrid.rowData = res.data
      })
    },
    async getCheckRuleDetail(uuid) {
      this.loading = getLoading()
      await getCheckRuleByUuid(uuid).then(res => {
        this.oneCheckRule = { ...res.data }
        this.resetOfficeGridCheck()
      }).finally(() => {
        this.loading.close()
      })
    },
    showAdd() {
      this.currOptStatus = this.optStatusDef.edit
      this.oneCheckRule = { ...this.initOneCheckRule }
      this.hqChecked = false
      this.resetOfficeGridCheck()
      this.setRuleGridCheck()
    },
    showEdit() {
      const row = this.getGridSelected(this.checkRuleGrid.gridOptions)
      if (row) {
        this.currOptStatus = this.optStatusDef.edit
        this.hqChecked = false
        this.officeGrid.gridOptions.api.setColumnDefs(this.getOfficeColumnDefs())
        this.officeGrid.gridOptions.api.forEachNode(node => {
          const currRuleOfficeUuids = [...this.oneCheckRule.officeUuids]
          if (currRuleOfficeUuids.includes(node.data.uuid)) {
            node.setSelected(true)
          } else {
            node.setSelected(false)
          }
        })
      }
    },
    async toDel() {
      const row = this.getGridSelected(this.checkRuleGrid.gridOptions)
      if (!row) {
        return
      }
      await Assert.isTrue(!this.isEdit, this.$t('Message.CurrentlyStatusAndCannotDeleted'))
      await this.$confirm(this.$t('SystemMaintenance.AreRuleAssociatedValidationDeleted'), this.$t('SystemMaintenance.Prompt'), { type: 'waring' })
      delCheckRule(this.oneCheckRule.uuid).then(res => {
        this.$message.success(this.$t('SystemMaintenance.DeleteSuccess'))
        this.initData(false)
      })
    },
    async checkForm() {
      if (this.oneCheckRule.checkNode !== CheckRuleConstants.NODE_SAVE_USER.code) {
        this.oneCheckRule.officeUuids = await getGridSelectedIds(this.officeGrid.gridOptions, 'uuid', this.$t('SystemMaintenance.PleaseSelectTheBranchOffice'))
      }
      const { ruleName,
        checkNode,
        checkCategory,
        checkMode,
        officeUuids } = this.oneCheckRule
      await Assert.isNotBlank(ruleName, this.$t('SystemMaintenance.PleaseEnterRuleName'))
      await Assert.isNotBlank(checkNode, this.$t('SystemMaintenance.PleaseSelectTheRuleNode'))
      await Assert.isNotBlank(checkCategory, this.$t('SystemMaintenance.PleaseSelectTheRuleType'))
      await Assert.isNotBlank(checkMode, this.$t('SystemMaintenance.PleaseSelectTheRuleMode'))
      // CARGO-31252 【保存用户】对所有公司生效
      if (this.oneCheckRule.checkNode !== CheckRuleConstants.NODE_SAVE_USER.code) {
        await Assert.isNotBlank(officeUuids, this.$t('SystemMaintenance.PleaseSelectTheBranchOffice'))
      }
      // 【操作指令验证】规则名称必须唯一
      if (this.oneCheckRule.checkNode === CheckRuleConstants.OPERATION_INSTRUCTION_VALID.code) {
        const canSave = await beforeSaveValid(this.oneCheckRule).then(res => res.data)
        await Assert.isTrue(canSave, lang.t('CargoMsg.Cargo_CheckRuleNameExist', [ruleName]))
      }
    },
    async save() {
      this.oneCheckRule.checkCriteria = this.$refs.checkCriteria.rowData || []
      this.oneCheckRule.checkExpression = this.$refs.checkExpression.rowData || []
      this.oneCheckRule.offices = this.oneCheckRule.offices ? this.oneCheckRule.offices : []
      await this.checkForm()
      this.loading = getLoading()
      for (const data of this.oneCheckRule.checkCriteria) {
        if (data.uuid.startsWith('addCriteria_')) {
          data.uuid = ''
        }
      }
      for (const data of this.oneCheckRule.checkExpression) {
        if (data.uuid.startsWith('addExpression_')) {
          data.uuid = ''
        }
      }
      saveCheckRuleFunc(this.oneCheckRule).then(async res => {
        if (this.oneCheckRule.uuid) {
          this.checkRuleGrid.rowData = this.checkRuleGrid.rowData.map(item => {
            if (item.uuid === res.data.uuid) return { ...res.data }
            return item
          })
        } else {
          this.checkRuleGrid.rowData = [{ ...res.data }, ...this.checkRuleGrid.rowData]
        }
        this.oneCheckRule = { ...res.data }
        this.setRuleGridCheck([res.data.uuid])
        this.$message.success(this.$t('SystemMaintenance.SaveSuccess'))
        this.cancel()
      }).finally(() => {
        this.loading.close()
      })
    },
    async cancel() {
      this.currOptStatus = this.optStatusDef.normal
      this.officeGrid.gridOptions.api.setColumnDefs(this.getOfficeColumnDefs())
    },
    getOfficeColumnDefs() {
      return [
        {
          headerName: '', width: 60,
          checkboxSelection: this.checkboxSelection,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: this.checkboxSelection, hide: !this.isEdit
        },
        {
          headerName: this.$t('SystemMaintenance.CompanyName'),
          field: 'chineseName',
          width: 200,
          sortable: true
        },
        {
          headerName: '',
          field: 'selected',
          width: 60,
          sortable: false,
          hide: this.isEdit,
          cellRenderer: (params) => {
            const currRuleOfficeUuids = [...this.oneCheckRule.officeUuids]
            if (currRuleOfficeUuids.includes(params.data.uuid)) {
              return '√'
            }
            return ''
          }
        }]
    },
    getGridSelected(gridOptions) {
      const cell = gridOptions.api.getFocusedCell()
      const nodes = gridOptions.api.rowModel.rowsToDisplay
      const node = (cell && nodes.length > 0) ? nodes.find(node => node.rowIndex === cell.rowIndex) : null
      if (!node || !node.data) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseSelectDataFirst'))
        return null
      }
      return node.data
    },
    onCheckNodeChange() {
      if (this.oneCheckRule.checkNode === this.NODE_SAVE_PARTNER.code || this.oneCheckRule.checkNode === this.NODE_COMMIT_PARTNER.code) {
        this.oneCheckRule.checkCategory = this.CATEGORY_REQUIRE.code
      } else if (this.oneCheckRule.checkNode === CheckRuleConstants.NODE_CRM_CUSTOMER_INPUT_SAVE.code) {
        this.oneCheckRule.checkCategory = CheckRuleConstants.CATEGORY_DATA_LOGIC.code
      }
    },
    filterCheckCriteria(checkNode, checkCriteriaCode) {
      if (checkNode === this.NODE_SAVE_PARTNER.code || checkNode === this.NODE_COMMIT_PARTNER.code) {
        return checkCriteriaCode === this.CATEGORY_REQUIRE.code || checkCriteriaCode === CheckRuleConstants.CATEGORY_DATA_LOGIC.code
      } else if (checkNode === CheckRuleConstants.NODE_CRM_CUSTOMER_INPUT_SAVE.code) {
        return checkCriteriaCode === CheckRuleConstants.CATEGORY_DATA_LOGIC.code
      }
      return true
    },
    showBranchSelectDialog() {
      this.branchSelectDialog.value = this.toNumArray(this.oneCheckRule.exclusionOfficeIds)
      this.branchSelectDialog.callback = val => {
        this.oneCheckRule.exclusionOfficeIds = this.toTxt(val)
      }
      this.branchSelectDialog.visible = true
    },
    toNumArray(txt) {
      if (txt) {
        return Array.from(txt.split(','), p => Number(p))
      }
      return []
    },
    toTxt(arr) {
      if (arr && arr.length > 0) {
        return arr.join(',')
      }
      return ''
    },
    async editCheckRuleSetting() {
      this.checkRuleSetDialog.form = await CheckRuleUtil.getCheckRuleSetting()
      this.checkRuleSetDialog.visible = true
    },
    onPopupModeChange() {
      if (!this.checkRuleSetDialog.form.popupMode) {
        this.checkRuleSetDialog.form.multiCheckNode = ''
        this.checkRuleSetDialog.form.multiCheckMode = ''
      }
    },
    async onSaveCheckRuleSet() {
      const form = this.checkRuleSetDialog.form
      if (form.popupMode) {
        if (!form.multiCheckNode) {
          this.$message.warning(this.$t('SystemMaintenance.VerificationNodeCannotBeEmpty'))
          return
        }
        if (!form.multiCheckMode) {
          this.$message.warning(this.$t('SystemMaintenance.VerificationModeCannotBeEmpty'))
          return
        }
      }
      await CheckRuleUtil.saveCheckRuleSetting(this.checkRuleSetDialog.form)
      this.$message.success(this.$t('SystemMaintenance.SaveSuccess'))
      this.checkRuleSetDialog.visible = false
    }
  }

}
</script>

<style scoped lang="scss">
  .check-rule .box-card>>>.el-card__header{
    padding:8px 20px!important;
    div{
      display: flex;
      justify-content: space-between;
    }
  }
  .check-rule .box-card>>>.el-card__body{
    height:calc(100% - 35px)!important;
  }
  .check-rule .not-click {
    pointer-events: none;
    cursor: move;
  }
  .check-rule{
    .left-rules{
      height: calc(100vh - 148px);
      /deep/ .el-card__body{
        padding: 0;
        .grid-wrapper{
          height: calc(100vh - 198.6px);
          &.isEdit{
            height: 340px;
          }
          .cargo-ag-grid{
            height: auto;
          }
        }
        .app-main-inner-row{
          width: 100%;
          box-sizing: border-box;
          .form-tip{
            margin-top: 10px;
            .el-radio-group{
              margin-left: 10px;
              label{
                margin-right: 15px;
              }
            }
          }
        }
      }
    }
    .company{
      height: calc(100vh - 148px);
      /deep/ .el-card__body{
        padding: 0;
        height: calc(100vh - 198.6px);
        .grid-wrapper{
          padding: 0;
          height: 100%
        }
      }
    }
    .check-rule-right{
      height: calc(100vh - 148px);
      /deep/ .container{
        height: calc(100vh - 198.6px);
      }
    }
  }

</style>
